import { BINARIES } from "./constants";
const encode = (data, structure, separator) => {
  let encoded = data.split("").map((val, idx) => BINARIES[structure[idx]]).map((val, idx) => val ? val[data[idx]] : "");
  if (separator) {
    const last = data.length - 1;
    encoded = encoded.map((val, idx) => idx < last ? val + separator : val);
  }
  return encoded.join("");
};
var stdin_default = encode;
export {
  stdin_default as default
};
